<template>
  <modal-component
    :active="showModal"
    @cancel="close"
    :titleModal="'Editar webhook'"
    @hdlOnClick="updateWebhook"
    :loader="loadingv2"
    textSave="Actualizar"
  >
    <div class="columns is-multiline">
        <div class="column is-6">
          <div class="field">
            <label class="label has-text-grey-light">Evento</label>
            <div class="select is-fullwidth">
              <select
                class="select"
                v-model="eventId"
                name="eventId"
                v-validate="'required'"
              >
                <option value="" selected disabled> Selecciona un evento </option>
                <option  v-for="event in events" :value="event.id" :key="event.id"> {{event.name}} </option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label has-text-grey-light">URL</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="URL"
                v-model="url"
                name="URL"
              >
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label has-text-grey-light">Headers</label>
            <div class="control">
              <textarea class="textarea" rows="4" name="headers" v-model="headers" placeholder="Headers"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label has-text-grey-light">Descripción</label>
            <div class="control">
              <textarea class="textarea" rows="4" name="description" v-model="description" placeholder="Descripción"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
  </modal-component>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import mixins from '../../mixins/formats'
export default {
  name: 'Webhooks',
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      default: () => {}
    },
    webhook: {
      type: Object
    },
    role: {
      type: Object
    },
    isLoading: {
      type: Boolean
    },
    probarWebhook: {
      type: Function
    }
  },
  data () {
    return {
      loadingv2: false,
      headers: '',
      url: '',
      description: '',
      eventId: Number,
      events: [],
      error: ''
    }
  },
  methods: {
    ...mapActions(['getFinancialEvents']),
    async getEventsList () {
      this.getFinancialEvents({ pagination: { pageNumber: 0, perPage: 100 }, paginator: false })
        .then(({ eventPages }) => {
          this.events = eventPages
        })
    },
    async updateWebhook () {}
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration
    })
  },
  mounted () {
    this.getEventsList()
    this.url = this.webhook?.url || ''
    this.eventId = this.webhook?.event?.id || ''
    this.headers = this.webhook?.headers || ''
    this.description = this.webhook?.description || ''
  }

}
</script>
